import { createFileRoute } from '@tanstack/react-router';

import { DocumentManager } from '@/components/document/DocumentManager';

export const Route = createFileRoute('/documents/$')({
  component: DocumentManager,
});
